import {defineStore} from 'pinia'

export const useChannelsGridStore = defineStore('channelsGrid', {
    state: () => ({
        loaded: false,
        channelsMap: {} as {[keys: string]: {[keys: string]: number}},
        ranges: {} as MapRanges,
        bands: [] as string[],
    }),
    getters: {
        channelsFreqMap: (state: any): MapOfChannels => {
            const map: { [keys: string]: { [keys: string]: number } } = {}
            for (const band of state.bands) {
                map[band] = state.channelsMap[band] || {}
            }
            return map
        },
        channelsFreqRanges: (state: any): MapRanges => {
            return state.ranges
        }
    },
    actions: {
        async load() {
            if (!this.loaded) {
                const response = await useApi().getChannelsMap()
                this.ranges = response.freqRanges
                this.bands = response.bands
                this.channelsMap = response.channelsMap
                this.loaded = true
            }
        },
    },
})

interface MapOfChannels {
    [keys: string]: {
        [keys: string]: number
    }
}

interface MapRanges {
    [keys: string]: string[]
}